export enum NAV_LEVEL {
  CONTEXT = 'context',
  METRIC_TYPE = 'metricType',
  TIME_PERIOD = 'timePeriod',
}

export enum ContextLink {
  PERFORMANCE = 'performance',
  TIMELINE = 'timeline',
  EVENTS = 'events',
  HISTORY = 'history',
  LIVE = 'live',
  SCHEDULED = 'scheduled',
  MAINTENANCE = 'maintenance',
}

export enum MetricTypeLink {
  ACTIVE = 'active',
  PRODUCTIVE = 'productive',
  UTILIZATION = 'utilization',
  PAID = 'paid',
}

export enum EventTypeLink {
  DETAILS = 'events/details',
  COMBINED = 'events/combined',
}

export enum MachinesScreen {
  PERFORMANCE = 'Performance',
  EVENTS = 'Events',
  HISTORY = 'History',
  LIVE = 'Live',
  SCHEDULED = 'Scheduled',
  MAINTENANCE = 'Maintenance',
  ACTIVE = 'Active',
  PRODUCTIVE = 'Productive',
  UTILIZATION = 'Utilization',
  PAID = 'Paid',
  TIMELINE = 'Timeline',
  EVENT_NC_FILE = 'EventNCFile',
  EVENT_DETAILS = 'EventDetails',
  EVENT_COMBINED = 'EventCombined',
  PHONE_INITIAL = 'PhoneInitial',
}

export enum NowSubScreen {
  PART = 'NowPart',
  JOB = 'NowJob',
  BATCH = 'NowBatch',
  NC_FILE = 'NowNCFile',
  TOOLS = 'NowTools',
}

export enum NowSubScreenTitles {
  PART = 'Part',
  JOB = 'Job',
  BATCH = 'Batch',
  NC_FILE = 'NC File',
  TOOLS = 'Tools',
}


export enum NowSubScreenLink {
  PART = 'part',
  JOB = 'job',
  BATCH = 'batch',
  NC_FILE = 'nc-file',
  ProductionOrder = 'production-order',
  TOOLS = 'tools',
}

export enum MODE {
  FULL = 'full',
  LIST = 'list',
  DETAILS = 'details',
}

export enum TimePeriod {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
  EIGHT_WEEKS = 'eightWeeks',
}

export enum MachineScreenContentState {
  LOADING = 'Loading',
  NO_CONNECTOR = 'NoConnector',
  CONNECTOR_OFF = 'ConnectorOff',
  ONBOARDING = 'Onboarding',
  ERROR = 'Error',
  NO_MACHINES = 'NoMachines',
  NO_MACHINE_SELECTED = 'NoMachineSelected',
  STATISTICS_ONLY = 'StatisticsOnly',
  NO_MACHINE_IN_PERIOD = 'NoMachineInPeriod',
  NO_DATA_IN_PERIOD = 'NoDataInPeriod',
  READY = 'Ready',
}